import TheGrid from '@/views/fees/grid'
import Edit from '@/views/fees/edit'
import TheView from '@/views/fees/view'

export default {
  path: '/fees',
  redirect: '/fees/index',
  name: 'fees',
  meta: {
    auth: {
      redirect: {
        name: 'fees.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Quotas'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'fees.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'fees.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'fees.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }, {
    path: 'view/:id',
    name: 'fees.view',
    component: TheView,
    meta: {
      auth: true,
      label: 'Ver'
    }
  }]
}
